<template>
  <div class="clearfix main_center">
    <div class="right-content clearfix busWinessRight">
      <el-card class="box-card" style="margin-bottom: 10px;">
        <div slot="header" class="clearfix">
          <span>基本信息</span>
        </div>

        <el-form
          label-width="200px"
          style="display: flex;flex-wrap: wrap;justify-content: space-between"
        >
          <el-form-item class="double-row" label="所属招标项目：">
            <span>{{ detail.tenderProjectName }}</span>
          </el-form-item>
          <el-form-item class="double-row" label="所属招标项目编号：">
            <span>{{ detail.tenderprojectCode }}</span>
          </el-form-item>
          <el-form-item class="double-row" label="评标专家委员会名称：">
            <span>评标</span>
          </el-form-item>
        </el-form>
      </el-card>
    

      <template >
          <el-card class="box-card" style="margin-bottom: 10px;">
            <div slot="header" class="clearfix">
              <span>专家抽取</span>
              <div class="get_result" @click="getResult">获取抽取结果</div>
              <!-- <div class="get_result">获取签到结果</div> -->
              <!-- <div class="get_result">获取补抽结果</div> -->

              <div class="v_print" v-if="expertStatus == '3'" @click="handleClickPrint" :disabled="expertStatus == '3' ?  false : true" >打印专家抽取结果表</div>
              <div class="v_print" v-if="expertStatus == '1' || expertStatus == '2' || expertStatus == '4' || expertStatus == '0'" style="color: #fff;background-color: rgb(215, 215, 215);border: 1px solid rgb(215, 215, 215);cursor: not-allowed;" >打印专家抽取结果表</div>
              

            </div>
            <el-table :data="detail.resultList" stripe border style="width: 100%;">
              <el-table-column label="序号" prop="index" width="50">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="姓名" prop="name" >
                <template slot-scope="scope">
                  <span v-if="expertStatus == '3'"> {{ scope.row.name }}</span>
                  <span v-if="expertStatus == '1' || expertStatus == '2' || expertStatus == '4' || expertStatus == '0'">{{ formatName(scope.row.name) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="手机号" prop="linkphone">
                <template slot-scope="scope">
                  <span v-if="expertStatus == '3'">{{ scope.row.linkphone }}</span>
                  
                  <span v-if="expertStatus == '1' || expertStatus == '2' || expertStatus == '4' || expertStatus == '0'">***********</span>
                </template>
              </el-table-column>
              <el-table-column
                label="身份证"
                prop="idcard"
                width="220"
              >
              <template slot-scope="scope">
                  <span v-if="expertStatus == '3'">{{ scope.row.idcard }}</span>
                  <span v-if="expertStatus == '1' || expertStatus == '2' || expertStatus == '4' || expertStatus == '0'">{{ formatIdcard(scope.row.idcard) }}</span>
                </template>
            </el-table-column>
              <el-table-column
                label="评标所在地"
                prop="pwxiaqu"
                width="220"
              >
              <template slot-scope="scope">
                <span v-if="expertStatus == '3'">{{ scope.row.pwxiaqu }}</span>
                  
                  <span v-if="expertStatus == '1' || expertStatus == '2' || expertStatus == '4' || expertStatus == '0'">****************</span>
                </template>
            </el-table-column>
              <el-table-column
                label="工作单位"
                prop="workUnit"
                width="250"
              >
              <template slot-scope="scope">
                <span v-if="expertStatus == '3'">{{ scope.row.workUnit }}</span>
                  
                  <span v-if="expertStatus == '1' || expertStatus == '2' || expertStatus == '4' || expertStatus == '0'">****************</span>
                </template>
            </el-table-column>
              <!-- authStatus 专家签章授权状态 -->
<!--              <el-table-column label="专家签章授权状态" prop="authStatus" :render-header="renderHeader">-->
<!--                <template slot-scope="scope" v-if="scope.row.authStatus">-->
<!--                  <el-tag :type="scope.row.authStatus == 1 ? 'success' : 'danger'">-->
<!--                      {{scope.row.authStatus == 1 ? '有效' : '无效'}}-->
<!--                  </el-tag>-->
<!--                </template>-->
<!--              </el-table-column>-->
              <!-- 正常，作废 -->
              <!-- <el-table-column label="专家状态" prop="status">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.status == '正常' ? 'success' : 'warning'">
                                    {{scope.row.status}}
                                </el-tag>
                </template>
              </el-table-column> -->
              <!-- 已签到，未签到 -->
              <!-- <el-table-column label="签到状态" prop="signStatus">
                <template slot-scope="scope">
                   <el-tag :type="scope.row.signStatus == '已签到' ? 'success' : 'warning'">
                                    {{scope.row.signStatus}}
                                </el-tag>
                </template>
              </el-table-column> -->
              <!-- <el-table-column label="签到时间" prop="signTime"></el-table-column> -->
              <el-table-column label="备注" prop="remark"></el-table-column>
            </el-table>
          </el-card>
    
          <el-card class="box-card" style="margin-bottom: 10px;">
            <div slot="header" class="clearfix">
              <span>业主专家</span>
              <!-- <div class="get_result">获取签到结果</div> -->
              <div class="get_result">获取补充结果</div>
            </div>
            <el-table :data="detail.tendersList" stripe border style="width: 100%;">
              <el-table-column label="序号" prop="index" width="50">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="姓名" prop="name">
                <template slot-scope="scope">
                  <span v-if="expertStatus == '3'"> {{ scope.row.name }}</span>
                  <span v-if="expertStatus == '1' || expertStatus == '2' || expertStatus == '4' || expertStatus == '0'">{{ formatName(scope.row.name) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="手机号" prop="linkphone">
                <template slot-scope="scope">
                  <span v-if="expertStatus == '3'">{{ scope.row.linkphone }}</span>
                  
                  <span v-if="expertStatus == '1' || expertStatus == '2' || expertStatus == '4' || expertStatus == '0'">***********</span>
                </template>
              </el-table-column>
              <el-table-column
                label="身份证"
                prop="code"
                width="220"
              > 
              <template slot-scope="scope">
                  <span v-if="expertStatus == '3'">{{ scope.row.code }}</span>
                  <span v-if="expertStatus == '1' || expertStatus == '2' || expertStatus == '4' || expertStatus == '0'">{{ formatIdcard(scope.row.code) }}</span>
                </template>
            </el-table-column>
              <el-table-column
                label="工作单位"
                prop="workUnit"
                width="250"
              >
              <template slot-scope="scope">
                <span v-if="expertStatus == '3'">{{ scope.row.workUnit }}</span>
                  
                  <span v-if="expertStatus == '1' || expertStatus == '2' || expertStatus == '4' || expertStatus == '0'">****************</span>
                </template>
            </el-table-column>
<!--              <el-table-column label="专家签章授权状态" prop="authStatus" :render-header="renderHeader1">-->
<!--                <template slot-scope="scope" v-if="scope.row.authStatus">-->
<!--                  <el-tag v-if='scope.row.authStatus == 1' :type="scope.row.authStatus == 1 ? 'success' : 'danger'">-->
<!--                      {{scope.row.authStatus == 1 ? '有效' : ''}}-->
<!--                  </el-tag>-->
<!--                </template>-->
<!--              </el-table-column>-->
              <!-- <el-table-column label="专家状态" prop="status"></el-table-column> -->
              <!-- <el-table-column label="签到状态" prop="signStatus"></el-table-column> -->
              <!-- <el-table-column label="签到时间" prop="signTime"></el-table-column> -->
              <el-table-column label="备注" prop="remark"></el-table-column>
            </el-table>
          </el-card>
        </template>

        <el-card
          class="box-card"
          style="margin-bottom:10px"
          v-if="expertStatus == '3'"
        >
          <div slot="header" class="clearfix">
            <span>审批流</span>
          </div>
          <el-table :data="auditHisTable" stripe border style="width: 100%;">
            <el-table-column
              type="index"
              header-align="center"
              align="center"
              label="序号"
              width="80"
            >
            </el-table-column>
            <el-table-column
              prop="taskName"
              align="left"
              :show-overflow-tooltip="true"
              width="200"
              label="步骤"
            >
            </el-table-column>
            <el-table-column
              prop="userName"
              align="left"
              :show-overflow-tooltip="true"
              width="250"
              label="办理人员"
            >
            </el-table-column>
            <el-table-column
              prop="excuteDate"
              align="center"
              width="250"
              label="处理时间"
            >
            </el-table-column>
            <el-table-column
              prop="auditMsg"
              align="left"
              :show-overflow-tooltip="true"
              label="描述/意见"
            >
            </el-table-column>
          </el-table>
        </el-card>

    </div>

    <div class="left-content busWinessLeft">
      <div class="left-navbar">
        <div class="pageInfo">
          <p class="title">系统标识码</p>
          <p>
            交易系统标识码<br />
            <span>{{ platformCode }}</span>
          </p>
          <p>
            公共服务平台标识码<br />
            <span>{{ pubServicePlatCode }}</span>
          </p>
        </div>

        <!-- 1待申请 2待授权 3已授权 4已拒绝 -->
        <el-button
           v-if="expertStatus == '1' || expertStatus == '2' || expertStatus == '4' || expertStatus == '0'"
           type="primary"
          style="display: flex;justify-content: center;"
           @click="applyView"
           >申请查看抽取结果</el-button
        >
        <el-button
           v-if="expertStatus == '3'"
           type="primary"
           :disabled="true"
           
           style="display: flex;justify-content: center;"
           >已申请查看抽取结果</el-button
         >
        <el-button
          type="primary"
          size="small"
          @click="showAuditWindow(true, '通过')"
          v-show="filingCBtn && isExpert"
          >同意</el-button
        >
        <el-button
          type="primary"
          plain
          size="small"
          @click="showAuditWindow(false, '不通过')"
          v-show="backCBtn && isExpert"
          >驳回</el-button
        >
        <el-button @click="back()" size="small">返回</el-button>
      </div>
    </div>

    <apply-modal
        :id="id"
        :isAudit="isExpert"
        :commitStatus="auditForm.isPass"
        :msg="auditForm.mark"
        :processinstanceid="processinstanceid"
        ref="applyRef"
        @refresh="getDetail"
        :applyStatus="expertStatus"
    ></apply-modal>


    <VPrint ref="printRef" :data='printData' />

  </div>
</template>

<script>
import ApplyModal from "./components/applyModal";
import VPrint from "@/components/VPrint";
import {tabsCloseCurrentHandle} from '@/utils/routeTab';

export default {
  components: { ApplyModal, VPrint },
  data() {
    return {
      auditForm: {
        mark: "",
        isPass: false
      },
      dialogVisible: false,
      detail: {
        resultList: [],
        tendersList: [],
      },
      platformCode: "",
      pubServicePlatCode: "",
      filingCBtn: false,
      backCBtn: false,
      auditHisTable: [],
      // 专家查看权限状态：0，1待申请 2待授权 3已授权 04已拒绝
      expertStatus: "0",
      // 项目是否抽取完成
      projectIsFinish: "1",
      isExpert: false,
      id: '',
      applyInfo: {},
      printData: {
        noCode: ''
      }
    };
  },




  methods: {

    // 列表姓名过滤
    formatName(name){
      console.log(name,'formatName');
      return name[0] + '**';
    },

    // 手机号    
    formatLinkphone(){
      return '***********';
    },

    // 身份证
    formatIdcard(idCard){
      return idCard.length > 4 ? '************** ' + idCard.slice(-4) : idCard;
    },

    renderHeader(h, { column }) {
      return h("span", [
        column.label,
        h("i", { 
          class: "el-icon-refresh",
          style: "cursor: pointer;",
          on: {
            click: () => {
              this.refreshAuthStatus()
            }
          }
        }),
      ]);
    },
    renderHeader1(h, { column }) {
      return h("span", [
        column.label,
        h("i", { 
          class: "el-icon-refresh",
          style: "cursor: pointer;",
          on: {
            click: () => {
              this.refreshAuthStatus1()
            }
          }
        }),
      ]);
    },
    refreshAuthStatus() {
      this.$http
        .get(`/expertController/refreshStateResultBXT?evalcommitteeBuildId=${this.id}&tenderCode=${this.tenderCode}`)
        .then((res) => {
          if (res.data.code == "1") {
            this.getDetail();
            // this.data.resultList = res.data.data
          } else {
            this.$message.error(res.data.msg)
          }
        });
    },
    refreshAuthStatus1() {
      this.$http
        .get(`/expertController/refreshStateTendersBXT?evalcommitteeBuildId=${this.id}&tenderCode=${this.tenderCode}`)
        .then((res) => {
          if (res.data.code == "1") {
            this.getDetail();
            // this.data.tendersList = res.data.data
          } else {
            this.$message.error(res.data.msg)
          }
        });
    },
    applyView() {
      this.$refs.applyRef.show({
        id: this.id,
        tenderProjectCode: this.detail.tenderprojectCode,
        tenderProjectName: this.detail.tenderProjectName
      })
    },
    auditProcess() {},
    showAuditWindow(isPass, msg) {
        //   this.dialogVisible = true;
        this.auditForm.mark = msg;
        this.auditForm.isPass = isPass;
        this.$refs.applyRef.show()
    },
    getFlow() {
      this.$http
        .get(`/expertController/history?processInstanceId=${this.processinstanceid}`)
        .then((res) => {
          if (res.data.code == "1") {
            this.auditHisTable = res.data.data.auditHistorys
          }
        })
    },
    getDetail() {
      this.$http
        .post(
          `/expertController/getExpertExtractionByEntityId?entityId=${this.id}`
        )
        .then((res) => {
          const { code, data } = res.data;
          if (code == 1) {
            this.detail = data;
            console.log(this.detail,'我看一眼抓夹抽取数据列表了🎁');
            console.log(this.detail.tendersList,'我看一下detail.tendersList');
            this.expertStatus = data.applyStatus
            console.log(data.applyStatus,'我看看授权状态');
            this.getBtnStatus()
            if (!this.processinstanceid) {
              this.processinstanceid = data.processinstanceid || ''
            }
            if (this.processinstanceid) {
              this.getFlow()
              this.getApplyUser()
            }
          }
        });
    },
    getApplyUser() {
      this.$http
        .get(`/expertController/newApplicant?processInstanceId=${this.processinstanceid}`)
        .then((res) => {
          if (res.data.code == "1") {
            this.applyInfo = res.data.data
          }
        })
    },
    getResult() {
      // loading
      this.$loading({
        lock: true,
        text: "正在获取抽取结果...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$http
        .post(
          `/expertController/getResult?evalcommitteeBuildId=${this.id}&id=${this.id}&tenderCode=${this.tenderCode}`
        )
        .then((res) => {
          const { code, data } = res.data;
          if (code == 1) {
            this.getDetail();
          }
          // close loading
          this.$loading().close();
        })
        .catch(() => {
          // close loading
          this.$loading().close();
        });
    },
    handleClickPrint() {
      this.$refs.printRef.print();
    },
    back() {
      tabsCloseCurrentHandle();
      this.$router.push({
        name: this.isExpert ? 'extractSignRev' : 'extractSign',
      })
    },
    getBtnStatus() {
        if (this.isExpert) {
            // expertStatus 为 2 放出审核按钮
            if (this.expertStatus == 2) {
                this.filingCBtn = true;
                this.backCBtn = true
            } else {
              this.filingCBtn = false;
              this.backCBtn = false
            }
        }
    }
  },

  activated(){
    this.id = this.$route.query.id;
    this.processinstanceid = this.$route.query.processinstanceid;
    this.isExpert = this.$route.query.type === "expert"; // expert || business
    this.tenderCode = this.$route.query.tenderCode;
    this.getDetail();
  },
  created() {
    this.id = this.$route.query.id;
    this.processinstanceid = this.$route.query.processinstanceid;
    this.isExpert = this.$route.query.type === "expert"; // expert || business
    this.tenderCode = this.$route.query.tenderCode;
    this.getDetail();
  },
};
</script>
<style lang="less" scoped>
.expoer_wrap {
  position: relative;

  .applaybtn {
    // position: absolute;
    // // 水平垂直居中
    // top: 50%;
    // left: 50%;
    // transform: translate(-50%, -50%);
  }

  img {
    width: 100%;
  }

  .project_status {
    position: absolute;
    top: 0;
    left: -20px;
    right: -20px;
    width: 100%;
    height: 48px;
    background: #cce4ff;
    display: flex;
    align-items: center;
    // margin-left: -20px;
    // margin-right: -20px;
    padding-left: 20px;
  }
}

.el-form /deep/ .el-form-item.double-row {
  width: 50%;
}

.right-content.busWinessRight {
  width: calc(100% - 160px);
}

.left-content.busWinessLeft {
  .left-navbar {
    width: 150px;
    border: none;
  }
}

.get_result {
  display: inline-block;
  border: 1px solid #409eff;
  border-radius: 4px;
  color: #409eff;
  padding: 5px 10px;
  margin-left: 10px;
  cursor: pointer;
}
.v_print {
  border: 1px solid #409eff;
  border-radius: 4px;
  color: #409eff;
  padding: 5px 10px;
  margin-left: 10px;
  float: right;
  cursor: pointer;
}


</style>
